import { AuthProvider, SignUpPage as AuthSignUpPage } from '@hub-la/fe-auth'

export const SignUpInit = () => {
  return (
    <AuthProvider>
      <AuthSignUpPage />
    </AuthProvider>
  )
}
